var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('p',{staticClass:"input-label my-1"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.val && _vm.val.file)?_c('div',[_vm._t("display")],2):_c('div',[_c('LogoUploader',_vm._b({attrs:{"editedImage":_vm.val},on:{"logoValidated":_vm.logoValidated,"logoCanceled":_vm.logoCanceled}},'LogoUploader',_vm.$attrs,false))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-032239d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/UploadInput.vue
// module id = null
// module chunks = 